import { Autocomplete, Button, Divider, TextField, Typography } from "@mui/material"
import { Stack } from "@mui/system"
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "../../../../hooks";
import { createConfirmEvent } from "../../../helpers/confirmEvents";
import { Field } from "../../miProfile/Field";
import { NumberInput } from "../../NumberInput";

export const AddForm = ({ userList, userRegisteredList }) => {

    const users = userList.filter(user => !userRegisteredList.includes(user.id));

    const { t } = useTranslation('global')
    const navigate = useNavigate()
    const [formValues, handleInputChange] = useForm({ principalAssistant: '', assistance: 'Si', companions: '', namePartner: users.map(user => user.name)[0] });

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const eventId = searchParams.get('event') 
    const name =  searchParams.get('name') 

    const { assistance, principalAssistant, companions, namePartner } = formValues;

    const handleConfirm = (e) => {
        e.preventDefault()
        const individualId = userList.find(user => user.name === namePartner).id;
        const assistanceBBDD = assistance === 'Si' ? 'Confirmada' : 'No';
        createConfirmEvent({ ...formValues, individualId, eventId, confirmsAttendance: assistanceBBDD }, t('addevent.confirmRegistered'), t('addevent.errorRegistered'), t('addevent.errorRegistered'), )
        navigate(-1)
    }
    const handleCancel = () => {
        navigate(-1)
    }

    return (
        <>
            <Stack direction='row' alignItems='center' gap={1}>
                <Typography color='primary' variant='h5'>{t('addevent.adminAddRegistered')} </Typography>
                <Typography color='secondary' variant='h5'>{name}</Typography>
            </Stack>
            <Divider sx={{ marginTop: 2, marginBottom: 3 }} />

            <form onSubmit={handleConfirm}>
                <Stack minHeight='calc(100vh - 290px)' gap={2}>

                    <Stack >
                        <Typography variant='overline' color='secondary'>{t('addevent.whoResponds')}</Typography>
                        <Autocomplete
                            disablePortal
                            options={users.map(user => user.name)}
                            size='small'
                            renderInput={(params) => <TextField  {...params} variant='outlined' name='namePartner' />}
                            value={namePartner}
                            onSelect={handleInputChange}
                            fullWidth
                            required
                        />
                    </Stack>
                    <Stack >
                        <Typography variant='overline' color='secondary'>{t('addevent.addInvestor')}</Typography>
                        <Autocomplete
                            disablePortal
                            options={["Si", "NO"]}
                            size='small'
                            renderInput={(params) => <TextField  {...params} variant='outlined' name='assistance' />}
                            value={assistance}
                            onSelect={handleInputChange}
                            fullWidth
                            required
                        />
                    </Stack>

                    <Stack direction='row' width='100%' gap={2}>
                        <Field translation='addevent' name={principalAssistant} title='principalAssistant' handleInputChange={handleInputChange} required={true} />
                        <NumberInput name={companions} title='companions' handleInputChange={handleInputChange} required={true} />
                    </Stack>

                </Stack>

                <Stack direction='row' justifyContent='end' gap={2} marginTop={3}>
                    <Button sx={{ width: '140px' }} color='secondary' onClick={handleCancel} variant="outlined">{t('myprofile.cancelButton')}</Button>
                    <Button sx={{ width: '140px' }} type='submit' variant="contained">{t('myprofile.confirmButton')}</Button>
                </Stack>
            </form>
        </>
    )
}
